module.exports = __webpack_public_path__ + "static/media/live.787a8ce9.png";